import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './SearchRegionDropdown.styles';
import { Region } from '@/api/types/regions.types';

interface SearchRegionDropdownProps {
  isOpen: boolean;
  regions: Region[];
  regionLegacyId: string;
  onSelect: (region: Region) => void;
}

export const SearchRegionDropdown = ({
  isOpen,
  regions,
  regionLegacyId,
  onSelect,
}: SearchRegionDropdownProps) => {
  const { t } = useTranslation();
  const hasList = regions.length > 0;

  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
  };

  return (
    <S.SearchRegionDropdownBox isOpen={isOpen}>
      <S.SearchRegionDropdownMenuWrapper>
        <S.SearchRegionDropdownMenu data-testid="search-region-dropdown-menu">
          {hasList ? (
            regions.map(region => {
              const { id, name, legacyResourceId } = region;
              const isSelected = +legacyResourceId === +regionLegacyId;

              return (
                <S.SearchRegionDropdownItem
                  data-testid={`search-region-dropdown-item-${id}`}
                  data-is-selected={isSelected}
                  key={id}
                  onClick={() => onSelect(region)}
                  onMouseDown={handleMouseDown}
                  $isSelected={isSelected}
                >
                  {name}
                </S.SearchRegionDropdownItem>
              );
            })
          ) : (
            <S.SearchRegionDropdownItem
              onMouseDown={e => e.preventDefault()}
              $isNotFound
              data-testid="search-region-dropdown-not-found"
            >
              {t('common.nothing_found')}
            </S.SearchRegionDropdownItem>
          )}
        </S.SearchRegionDropdownMenu>
      </S.SearchRegionDropdownMenuWrapper>
    </S.SearchRegionDropdownBox>
  );
};
